import { Link } from 'react-router-dom';
import { disciplines } from '../../data/mockData';
import Icon from '../ui/Icon';
import SectionHeading from '../ui/SectionHeading';

export default function Disciplines() {
  return (
    <section className="bg-white">
      <div className="section-shell">
        <SectionHeading
          eyebrow="What we teach"
          title="Fields you can qualify in"
          description="Four accredited learnerships and six vendor certification programmes, all built around the roles South African employers are actually hiring for."
        />

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {disciplines.map((item) => (
            <Link
              key={item.id}
              to="/learnerships"
              className="card-surface card-surface-hover group flex items-start gap-4 p-5"
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl ${item.tint}`}
              >
                <Icon name={item.icon} className="h-6 w-6" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-base font-bold text-brand-950">
                  {item.name}
                </span>
                <span className="mt-1 block text-sm leading-snug text-brand-900/55">
                  {item.summary}
                </span>
                <span className="mt-2.5 block text-xs font-semibold uppercase tracking-wide text-brand-600">
                  {item.programmeCount}{' '}
                  {item.programmeCount === 1 ? 'programme' : 'programmes'}
                </span>
              </span>
              <svg
                className="mt-1 h-5 w-5 shrink-0 text-brand-300 transition-transform group-hover:translate-x-1 group-hover:text-brand-600"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="m9 6 6 6-6 6" />
              </svg>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
